export const LocalStorageKey = {
  ASSET_TOKENS: 'ASSET_TOKENS',
};
